import { render, staticRenderFns } from "./SalePartnerships.vue?vue&type=template&id=e0dc1f3c&"
import script from "./SalePartnerships.vue?vue&type=script&lang=js&"
export * from "./SalePartnerships.vue?vue&type=script&lang=js&"
import style0 from "./SalePartnerships.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports